import { AgnesBadge, AgnesBadgeProps, cn } from '@agnes/ui';
import { cva, VariantProps } from 'class-variance-authority';
import {
  RUBRICA_UTILIZACAO_FOLHA_PAGAMENTO_NOMES,
  RubricaUtilizacaoFolhaPagamento,
} from '@/constants/rubricas/utilizacao-folha-pagamento/RubricaUtilizacaoFolhaPagamento';

const badgeCVA = cva('whitespace-nowrap', {
  variants: {
    utilizacao: {
      UTILIZADA:
        'bg-agnes-success/10 dark:bg-agnes-success/30 text-agnes-success dark:text-agnes-success-light',
      NAO_UTILIZADA:
        'bg-agnes-neutral/10 dark:bg-agnes-neutral/30 text-agnes-neutral dark:text-agnes-neutral-light',
    },
  },
});

export interface BadgeRubricaUtilizacaoFolhaPagamentoProps
  extends VariantProps<typeof badgeCVA>, Omit<AgnesBadgeProps, 'children'> {
  utilizacao: RubricaUtilizacaoFolhaPagamento;
}

export function BadgeRubricaUtilizacaoFolhaPagamento({
  className,
  utilizacao,
  size,
  ...props
}: BadgeRubricaUtilizacaoFolhaPagamentoProps) {
  return (
    <AgnesBadge className={cn(badgeCVA({ utilizacao }), className)} size={size} {...props}>
      {RUBRICA_UTILIZACAO_FOLHA_PAGAMENTO_NOMES[utilizacao]}
    </AgnesBadge>
  );
}
